export default "__VITE_ASSET__BvrK3TsP__"